import compareAmounts from "../../../objects/CommonUse/compare_amounts";

export const createConditionsTable = (conditionClass, primaryFieldName, fieldID, 
   additionalFieldArr, conditionsList) => {
 
// conditions table is the conditionsTable that is currently on the player
// conditionClass is the class that is being processed (ex: car, home, etc)
// primaryFieldName is the id field for the class (carID, homeID, etc)
// fieldID is the value of the id field
// additionalFieldArr is an array that contains a list of fields/values that a   re valid for this condition
// conditionsList is the full conditionsList collection

   var i;
   var j;
   var k;
   var compareValuesArr=[];
   var createCondition = false;
   var conditionsTable = [];
   // determine what entries should be added 
   for (i=0; i<conditionsList.length; i++){
         if (conditionsList[i].conditionClass ===  conditionClass){ 
            compareValuesArr = conditionsList[i].compareValues; 
            if (conditionsList[i].primaryFieldName ===  primaryFieldName ){
               for (j=0; j<compareValuesArr.length; j++){
                  //   create entries in condition table if they match the ID of the chosen item 
                  if (compareValuesArr[j] ===  fieldID){
                     let conditionObj = {condName: conditionsList[i].condName, 
                        conditionClass: conditionsList[i].conditionClass }
                     conditionsTable.push(conditionObj); 
                  }
               }
            }
         }
   }         
   createCondition = false;
   for (j=0; j<additionalFieldArr.length && createCondition ===  false; j++){
      // additionalFieldArr is an object with fieldName, gameValue 
      
      for (i=0; i<conditionsList.length; i++){
         if (conditionsList[i].conditionClass ===  conditionClass){  
                  compareValuesArr = conditionsList[i].compareValues; 
                  if (conditionsList[i].primaryFieldName ===  additionalFieldArr[j].fieldName){
                     if (conditionsList[i].relationType ===  "EQ"){
                        for (k=0; k<compareValuesArr.length; k++){
                           if (isNaN(+additionalFieldArr[j].fieldValue)){
                              if (additionalFieldArr[j].fieldValue === compareValuesArr[k]){
                                 createCondition = true;
                              }
                           }else{
                              if (+additionalFieldArr[j].fieldValue ===  +compareValuesArr[k]){
                                 createCondition = true;
                              }
                           }
                        }
                     }else{
                           createCondition = compareAmounts(compareValuesArr[0], 
                                 conditionsList[i].relationType, +additionalFieldArr[j].fieldValue );
                                          
                     }
                     if (createCondition ===  true){
                        let conditionObj = {condName: conditionsList[i].condName, 
                           conditionClass: conditionsList[i].conditionClass }
                        conditionsTable.push(conditionObj);
                        createCondition = false; 
                     }
                  }
            }
            
         }
   }
            
   return conditionsTable;
   
}





